import axios from "axios";
import store from "@/store";

class api {
  constructor() {
    this.axios = axios.create({
      baseURL: process.env.VUE_APP_API_BASE_URL,
      //baseURL: process.env.VUE_APP_PROXY_PATH,
    });
  }

  async get(
    endPoint,
    successCallback = null,
    failCallback = null,
    addHeader = false
  ) {
    let header = {
      headers: {
        contentType: "application/json",
      },
    };
    if (store.getters.token && addHeader) {
      header = {
        headers: {
          token: store.getters.token,
          contentType: "application/json",
        },
      };
    }
    const result = this.axios
      .get(endPoint, header)
      .then((res) => {
        if (!this._resultParse(res)) return;
        if (successCallback) {
          successCallback(res);
        }
        return res.data.data;
      })
      .catch((err) => {
        if (failCallback) {
          failCallback(err);
        }
        console.log("サーバーエラーが発生しました");
        return err;
      });
    return result;
  }

  async post(endPoint, params = null, addHeader = true) {
    store.commit("setErrors", "");
    let header = {
      headers: {},
    };
    if (addHeader)
      header = {
        headers: {
          token: store.getters.token,
          contentType: "application/json",
        },
      };
    const result = this.axios
      .post(endPoint, params, header)
      .then((res) => {
        if (!this._resultParse(res)) {
          return;
        }
        store.commit("setErrors", res.data.data.errors);
        return res.data.data;
      })
      .catch((err) => {
        console.log("サーバーエラーが発生しました");
        return err;
      });
    return result;
  }

  _resultParse(res) {
    if (res.data.data.state == 444) {
      return false;
    }
    if (res.data.data.state == 500) {
      console.log("サーバーエラーが発生しました");
      return false;
    }
    store.commit("setToken", res.data.data._code);
    return true;
  }
}

export default api;
